module.exports = __webpack_public_path__ + "media/sidebar/sales-cd1c72d5.svg";